import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-3xl mx-4 md:mx-6 mt-20">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2 mb-5 group">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-layout-grid-line text-background-50 text-base w-4 h-4 flex items-center justify-center"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                GTBuy
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-sm">
              Your trusted hub for spreadsheet-based shopping comparison. We help you navigate structured product data from GTBuy, Kakobuy, and Superbuy spreadsheet systems.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-semibold text-sm text-background-50 mb-4">Quick Links</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 py-0.5 whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-semibold text-sm text-background-50 mb-4">Explore</h4>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
              >
                Home
              </Link>
              <Link
                to="/gtbuy-spreadsheet-ultimate-guide"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
              >
                Ultimate Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
              >
                KASpreadsheet Store
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-semibold text-sm text-background-50 mb-4">Main Store</h4>
            <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
              Visit our main store at KASpreadsheet for the complete shopping experience with all categories and products.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-50/20 text-background-50 text-sm font-medium rounded-full hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors underline underline-offset-4">
              Twitter / X
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors underline underline-offset-4">
              Instagram
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors underline underline-offset-4">
              Pinterest
            </a>
          </div>
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} GTBuy Spreadsheet. This is an informational comparison platform.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors underline underline-offset-4">
              Privacy
            </Link>
            <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors underline underline-offset-4">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}